import { render, staticRenderFns } from "./HelpDocument.vue?vue&type=template&id=63e049ec&scoped=true&"
import script from "./HelpDocument.vue?vue&type=script&lang=js&"
export * from "./HelpDocument.vue?vue&type=script&lang=js&"
import style0 from "./HelpDocument.vue?vue&type=style&index=0&id=63e049ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e049ec",
  null
  
)

export default component.exports